<template>
  <div>
    <AdminDashboardView v-if="userType === 'Admin'" />
    <EmployeeDashboardView v-else />
  </div>
</template>

<script setup lang="ts">
import { useUser } from '@/composables/auth/useUser'
import AdminDashboardView from './AdminDashboardView.vue'
import EmployeeDashboardView from './EmployeeDashboardView.vue'

const { userType } = useUser()
</script>
